import React from "react";

export default function FileInputField({
  id,
  label,
  file,
  existingFileName,
  previewUrl,
  disabled,
  error,
  accept = "image/*,application/pdf",
  className = "",
  onChange,
  onDelete,
}) {
  const displayName = file?.name || existingFileName;
  const imageName = file?.name || existingFileName || "";
  const isPdf =
    (file && file.type === "application/pdf") || /\.pdf$/i.test(imageName);
  const isImageFile =
    (file && file.type.startsWith("image/")) ||
    /\.(png|jpe?g|gif|webp|svg|bmp|avif|heic|heif)$/i.test(imageName);
  const showImagePreview = Boolean(previewUrl) && !isPdf && (isImageFile || !file);

  return (
    <div className={className}>
      <label className="mb-2 block font-medium text-gray-700" htmlFor={id}>
        {label}
      </label>
      <div
        className={`flex items-center gap-3 rounded-lg border px-3 py-2 shadow-sm transition focus-within:ring-2 focus-within:ring-[#3cba84] ${
          error ? "border-red-500" : "border-gray-300"
        } ${disabled ? "cursor-not-allowed opacity-60" : ""}`}
      >
        <input
          type="file"
          id={id}
          accept={accept}
          disabled={disabled}
          onChange={disabled ? undefined : onChange}
          className="flex-1 min-w-0 text-sm file:mr-3 file:rounded-md file:border-0 file:bg-[#eaf6f1] file:px-3 file:py-1.5 file:text-sm file:font-medium file:text-[#004276] hover:file:bg-[#d9efe6] disabled:cursor-not-allowed"
        />
      </div>
      {displayName && (
        <div className="mt-2 flex items-center justify-between gap-2 rounded-md bg-gray-50 px-3 py-2">
          <p className="min-w-0 truncate text-xs text-gray-600">{displayName}</p>
          <div className="flex shrink-0 items-center gap-1">
            {previewUrl && !isImageFile && (
              <a
                href={previewUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="rounded px-2 py-1 text-xs font-medium text-[#004276] transition hover:bg-[#eaf6f1]"
              >
                View
              </a>
            )}
            {!disabled && onDelete && (
              <button
                type="button"
                onClick={onDelete}
                className="shrink-0 rounded p-1 text-red-500 transition hover:bg-red-50 hover:text-red-700"
                title="Remove file"
              >
                <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                  />
                </svg>
              </button>
            )}
          </div>
        </div>
      )}
      {showImagePreview && (
        <div className="mt-2 inline-block rounded-lg border border-gray-200 bg-gray-50 p-2">
          <img
            src={previewUrl}
            alt={`${label} preview`}
            className="block max-h-24 max-w-[120px] object-contain"
          />
        </div>
      )}
      {file && isPdf && !previewUrl && (
        <p className="mt-2 text-xs text-gray-600">PDF selected — preview not available</p>
      )}
      {error && <p className="mt-1 text-xs text-red-600">{error}</p>}
    </div>
  );
}

